<template>
  <div class="works-component">
    <div class="amalfi-coast-title amalfi-coast">Works.</div>
    <div class="noto noto-display-xl-400 gray-400  letter-spacing" >工程作品</div>
    <div class="works-tab container">
      <div class="row"  :class="{ 'fixed': isFixed  }" >
        <b-tabs content-class="mt-3">
          <b-tab title="ALL" active>
            <b-row sm>
              <b-col v-for="(item, index) in works" :key="index" :to="item.link" tag="router-link" md="4" sm>
                <img :src="require(`@/assets/img/works/${item.img}`)" :alt="item.alt">
                <div class="pd-16">
                  <div class="playfair playfair-title-sm-400 black">{{ item.title }}</div>
                  <span class="inter inter-body-md-400 gray-400">{{ item.location }}</span>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="BUNGALOW">
            <b-row sm>
              <b-col v-for="(item, index) in bungalowWorks" :key="index" :to="item.link" tag="router-link" md="4" sm>
                <img :src="require(`@/assets/img/works/${item.img}`)" :alt="item.alt">
                <div class="pd-16">
                  <div class="playfair playfair-title-sm-400 black">{{ item.title }}</div>
                  <span class="inter inter-body-md-400 gray-400">{{ item.location }}</span>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="SEMI-D" >
            <b-row sm>
              <b-col v-for="(item, index) in semiDWorks" :key="index" :to="item.link" tag="router-link" md="4" sm>
                <img :src="require(`@/assets/img/works/${item.img}`)" :alt="item.alt">
                <div class="pd-16">
                  <div class="playfair playfair-title-sm-400 black">{{ item.title }}</div>
                  <span class="inter inter-body-md-400 gray-400">{{ item.location }}</span>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="LINK HOUSE / CONDO" >
            <b-row sm>
              <b-col v-for="(item, index) in linkHouseCondoWorks" :key="index" :to="item.link" tag="router-link" md="4" sm>
                <img :src="require(`@/assets/img/works/${item.img}`)" :alt="item.alt">
                <div class="pd-16">
                  <div class="playfair playfair-title-sm-400 black">{{ item.title }}</div>
                  <span class="inter inter-body-md-400 gray-400">{{ item.location }}</span>
                </div>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab title="DESIGN CONCEPT" ><p>I'm a disabled tab!</p></b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'worksComponent',
  data() {
    return {
      isFixed: false,
      works: [
        { img: 'bungalow/00-hero-banner.jpg', title: '白 + 木 | White + Wood', location: 'Semi D, Eco Spring | Johor', link: 'White-Wood', alt: '01-bungalow-white+wood' },
        { img: 'semi-d/01-漫乐- Romance in the house -ECO SPRING-JOHOR/00-hero banner.jpg', title: '漫乐 | Romance in the house', location: 'Eco Spring | Johor', link: 'Romance-In-The-House', alt: '02-bungalow-romance-in-the-house' },
        { img: 'semi-d/02-墨- PERFECT IN BLACK- WIRA HEIGHT SG LONG- KAJANG/00-hero banner.jpg', title: '墨 | Perfect in Black', location: 'Wira Height Sg Long | Kajang', link: 'Perfect-In-Black', alt: '03-bungalow-comfort' },
        { img: 'semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/00-hero banner.jpg', title: '归 | Home', location: 'Longbranch | Kota Kemunting', link: 'Gui-Home', alt: '04-bungalow-grey-song' },
        { img: 'link-house-condo/01-沐光 MU-TAMAN CANTIK-KUALA LUMPUR/00-hero banner.jpg', title: '沐光 | Mu', location: 'Taman Cantik | Kuala Lumpur', link: 'Mu', alt: '05-bungalow-grey-song' },
        { img: 'link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/00-hero banner.jpg', title: '舒窝 | Comfort Zone', location: 'Sunway Mont | Mont Kiara', link: 'Comfort-Zone', alt: '06-bungalow-grey-song' },
        { img: 'link-house-condo/03-岩灰-GREY SONG -KIARAVILLE -MONT KIARA/00-hero banner.jpg', title: '岩灰 | Grey Song', location: 'Kiaraville | Mont Kiara', link: 'Grey-Song', alt: '07-bungalow-grey-song' },
        { img: 'link-house-condo/04-悠-SERENITY- SUNWAY MONT -MONT KIARA/00-hero banner.jpg', title: '悠 | Serenity', location: 'Sunway Mont | Mont Kiara', link: 'Serenity', alt: '08-bungalow-grey-song' },
        { img: 'link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/00-hero banner.jpg', title: '樱 | Sakura', location: 'Rimbun Vista | Seremban', link: 'Sakura', alt: '09-bungalow-grey-song' },
        { img: 'link-house-condo/06-云-CLOUD-RESIDENSI 22-MONT KIARA/00-hero banner.jpg', title: '云 | Cloud', location: 'Residensi 22 | Mont Kiara', link: 'Cloud', alt: '10-bungalow-grey-song' },
        { img: 'link-house-condo/07-蓝色小时-BLU-ECO MAJESTIC MELLOWOOD- SEMENYIH/00-hero banner.jpg', title: '蓝色小时 | Blue', location: 'Eco Majestic Mellowood', link: 'Blue', alt: '11-bungalow-grey-song' },
        { img: 'link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/00-hero banner.jpg', title: '青禾 | Jade', location: 'Landmark Residence | Kajang', link: 'Jade', alt: '12-bungalow-grey-song' },
        { img: 'link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/00-hero banner.jpg', title: '色彩生活 | Colours', location: 'Semanja Kajang | Kajang', link: 'Colours', alt: '13-bungalow-grey-song' },
        { img: 'link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/00-hero banner.jpg', title: '石 | Rock', location: 'KM1 | Bukit Jalil', link: 'Rock', alt: '14-bungalow-grey-song' }
      ],
      bungalowWorks: [
        { img: 'bungalow/00-hero-banner.jpg', title: '白 + 木 | White + Wood', location: 'Semi D, Eco Spring | Johor', link: 'White-Wood', alt: '01-bungalow-white+wood' }, 
      ],
      semiDWorks:[
        { img: 'semi-d/01-漫乐- Romance in the house -ECO SPRING-JOHOR/00-hero banner.jpg', title: '漫乐 | Romance in the house', location: 'Eco Spring | Johor', link: 'Romance-In-The-House', alt: '02-bungalow-romance-in-the-house' },
        { img: 'semi-d/02-墨- PERFECT IN BLACK- WIRA HEIGHT SG LONG- KAJANG/00-hero banner.jpg', title: '墨 | Perfect in Black', location: 'Wira Height Sg Long | Kajang', link: 'Perfect-In-Black', alt: '03-bungalow-comfort' },
        { img: 'semi-d/03-归-HOME-LONGBRANCH-KOTA KEMUNTING/00-hero banner.jpg', title: '归 | Home', location: 'Longbranch | Kota Kemunting', link: 'Gui-Home', alt: '04-bungalow-grey-song' },
      ],
      linkHouseCondoWorks:[
        { img: 'link-house-condo/01-沐光 MU-TAMAN CANTIK-KUALA LUMPUR/00-hero banner.jpg', title: '沐光 | Mu', location: 'Taman Cantik | Kuala Lumpur', link: 'Mu', alt: '05-bungalow-grey-song' },
        { img: 'link-house-condo/02-舒窝 -COMFORT ZONE -SUNWAY MONT- MONT KIARA/00-hero banner.jpg', title: '舒窝 | Comfort Zone', location: 'Sunway Mont | Mont Kiara', link: 'Comfort-Zone', alt: '06-bungalow-grey-song' },
        { img: 'link-house-condo/03-岩灰-GREY SONG -KIARAVILLE -MONT KIARA/00-hero banner.jpg', title: '岩灰 | Grey Song', location: 'Kiaraville | Mont Kiara', link: 'Grey-Song', alt: '07-bungalow-grey-song' },
        { img: 'link-house-condo/04-悠-SERENITY- SUNWAY MONT -MONT KIARA/00-hero banner.jpg', title: '悠 | Serenity', location: 'Sunway Mont | Mont Kiara', link: 'Serenity', alt: '08-bungalow-grey-song' },
        { img: 'link-house-condo/05-樱 SAKURA -RIMBUN VISTA- SEREMBAN/00-hero banner.jpg', title: '樱 | Sakura', location: 'Rimbun Vista | Seremban', link: 'Sakura', alt: '09-bungalow-grey-song' },
        { img: 'link-house-condo/06-云-CLOUD-RESIDENSI 22-MONT KIARA/00-hero banner.jpg', title: '云 | Cloud', location: 'Residensi 22 | Mont Kiara', link: 'Cloud', alt: '10-bungalow-grey-song' },
        { img: 'link-house-condo/07-蓝色小时-BLU-ECO MAJESTIC MELLOWOOD- SEMENYIH/00-hero banner.jpg', title: '蓝色小时 | Blue', location: 'Eco Majestic Mellowood', link: 'Blue', alt: '11-bungalow-grey-song' },
        { img: 'link-house-condo/08-青禾 JADE- LANDMARK RESIDENCE-KAJANG/00-hero banner.jpg', title: '青禾 | Jade', location: 'Landmark Residence | Kajang', link: 'Jade', alt: '12-bungalow-grey-song' },
        { img: 'link-house-condo/09-色彩生活-COLOURS- SEMANJA KAJANG -KAJANG/00-hero banner.jpg', title: '色彩生活 | Colours', location: 'Semanja Kajang | Kajang', link: 'Colours', alt: '13-bungalow-grey-song' },
        { img: 'link-house-condo/10-石-ROCK-KM1-BUKIT JALIL/00-hero banner.jpg', title: '石 | Rock', location: 'KM1 | Bukit Jalil', link: 'Rock', alt: '14-bungalow-grey-song' }
      ]
    }
  },
  methods: {
    handleScroll() {
      const navTabs = document.querySelector('.nav-tabs');
      if (window.scrollY > navTabs.offsetTop) { 
        this.isFixed = true;
      } else { 
        this.isFixed = false;
      }
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

}
</script>

<style>
.works-component {
  padding-top: 72px;
}

.works-component .amalfi-coast-title {
  padding-bottom: 4rem;
}

.letter-spacing {
  letter-spacing: 0.5em;
  padding-bottom: 56px
}

.nav {
  justify-content: center;
}

.works-component .nav-link {
  width: 210px;
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #8E8E93;
  padding: 32px 0;
}
.works-component .nav-tabs {
  margin-bottom: 56px;
}
.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active,
.nav-tabs .nav-link:focus,
.nav-tabs .nav-link:hover {
  border-bottom: 2px solid black !important;
  border: 0;
  color: black; 
}

.fixed .nav-tabs {
  position: fixed;
  /* When scrolled, this will make it fixed */
  top: 72px;
  left: 0;
  right: 0;
  z-index: 1;
  background-color: white;
  
}

.works-tab {
  padding-bottom: 56px;
}
.works-tab img{
  width: 384px;
  height: 256px; 
  object-fit: cover;
}
.works-tab .row .col {
  padding-top: 56px;

}

img {
  width: 100%
}
a{
  text-decoration: none !important;
}
@media (max-width: 992px) {
  .works-component img {
        width: 100%;
    }
}
@media (max-width: 576px) {
  .works-component .nav-link {
    width: 114px;
    padding: 16px 0 16px;
  }

  .works-component .nav-item:nth-child(1) .nav-link,
  .works-component .nav-item:nth-child(2) .nav-link,
  .works-component .nav-item:nth-child(3) .nav-link {
    border-bottom: 1px solid #dee2e6;
  }

  .works-component .nav-item:nth-child(4) .nav-link,
  .works-component .nav-item:nth-child(5) .nav-link {
    width: 132px;
  }

  .nav-tabs .nav-item:nth-child(4).show .nav-link,
  .nav-tabs .nav-item:nth-child(4) .nav-link.active,
  .nav-tabs .nav-item:nth-child(5).show .nav-link,
  .nav-tabs .nav-item:nth-child(5) .nav-link.active {
    border-top: 1px solid #dee2e6 !important;
  }

  .works-component img {
        width: 100%;
    }
}
</style>